export default __webpack_public_path__ + "static/media/valeur-agilite.b0ea901c.jpg";